import request from '../index'
// 视频资源相关API

/**
 * 登录
 * @returns
 */
export const login = (data) =>{
  return request({
    url: '/member/user/login/loginByGoogle',
    method: 'post',
    data
  });
}

export const getUserInfo = (data) =>{
  return request({
    url: '/user/info',
    method: 'get',
    data
  });
}
export const sendEamil = (data) =>{
  return request({
    url: '/member/user/email/code',
    method: 'post',
    data
  });
}
export const checkEamil = (data) =>{
  return request({
    url: '/member/user/email/check',
    method: 'post',
    data
  });
}
export const registerEamil = (data) =>{
  return request({
    url: '/member/user/email/register',
    method: 'post',
    data
  });
}
export const resetPassword = (data) =>{
  return request({
    url: '/member/user/email/resetPassword',
    method: 'post',
    data
  });
}
export const eamilLogin = (data) =>{
  return request({
    url: '/member/user/login/email/',
    method: 'post',
    data
  });
}
/**
 * 获取X登录地址
 * @returns
 */
export const getXLoginUrl = (data) =>{
  return request({
    url: '/member/user/login/getXLoginUrl',
    method: 'post',
    data
  });
}
/**
 * 获取Discord登录地址
 * @returns
 */
export const getDiscordLoginUrl = (data) =>{
  return request({
    url: '/member/user/login/getDiscordLoginUrl',
    method: 'post',
    data
  });
}
/**
 * X登录
 * @returns
 */
export const loginByX = (data) =>{
  return request({
    url: '/member/user/login/loginByX',
    method: 'post',
    data
  });
}
/**
 * Discord登录
 * @returns
 */
export const loginByDiscord = (data) =>{
  return request({
    url: '/member/user/login/loginByDiscord',
    method: 'post',
    data
  });
}